import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {ArtistModel} from "../../models/artist.model";
import {FormControl} from "@angular/forms";
import {UserTagModel} from "../../models/user-tag.model";
import {ActivatedRoute} from "@angular/router";
import {map} from "rxjs/operators";
import {combineLatest, Subscription} from "rxjs";
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-artists',
  templateUrl: './artists.component.html',
  styleUrls: ['./artists.component.css']
})
export class ArtistsComponent implements OnInit, OnDestroy {
  artists: ArtistModel[];
  artistsFiltered: ArtistModel[];
  tagToFilter: UserTagModel;
  showAddArtists = false;
  showOptionsMenu = false;
  artistFilter = new FormControl('');
  tagEditedSubscription: Subscription;
  loading$ = this.loadingService.loading$;

  constructor(private spotifyTagsService: SpotifyTagsService, private route: ActivatedRoute, private loadingService: LoadingService) {}

  ngOnInit() {
    this.tagEditedSubscription = this.spotifyTagsService.tagEdited$.subscribe(editedTag => this.tagToFilter = editedTag);

    combineLatest(this.route.params, this.route.queryParams)
        .pipe(map(results => ({tagId: results[0].tagId, syncParam: results[1]})))
        .subscribe(params => {
          if (params.syncParam.sync) {
            this.synchronise();
          } else {
            const tagId = params.tagId;
            this.getArtists(tagId);
          }
        });
  }

  getArtists(tagId) {
    this.spotifyTagsService.getArtists(tagId ? Number(tagId) : null).subscribe(
        response => {
          this.artists = response.artists;
          this.artistsFiltered = response.artists;
          this.tagToFilter = response.tag;
          this.artistFilter.valueChanges.subscribe(value => {
            if (!value) {
              this.artistsFiltered = this.artists;
            } else {
              this.artistsFiltered = this.artists.filter(artist => artist.name.toLowerCase().includes(value.toLowerCase()));
            }
          });
        }
    );
  }

  synchronise() {
    this.artists = null;
    this.spotifyTagsService.syncWithSpotify().subscribe(() => {
      this.getArtists(null);
    });
  }

  ngOnDestroy(): void {
    this.tagEditedSubscription.unsubscribe();
  }

  updateArtists() {
    this.showAddArtists = false;
    this.showOptionsMenu = false;
    this.artists = null;
    this.spotifyTagsService.getArtists(this.tagToFilter ? this.tagToFilter.tagId : null).subscribe(response => {
      this.artists = response.artists;
      this.artistsFiltered = response.artists;
    });
  }

  openAddArtists() {
    this.showAddArtists = true;
  }

  toggeOptionsMenu(event: Event) {
    event.stopPropagation();
    this.showOptionsMenu = !this.showOptionsMenu;
  }

  @HostListener('click')
  hideOptionsMenuAgain() {
    this.showOptionsMenu = false;
  }

  @HostListener('document:click')
  hideOptionsMenu() {
    this.showOptionsMenu = false;
  }

  openInSpotify(artist: ArtistModel) {
    window.location.href = artist.uri;
  }

  editTag() {
    this.spotifyTagsService.passEditTag(this.tagToFilter);
    this.showOptionsMenu = false;
  }

  deleteTag() {
    this.spotifyTagsService.passDeleteTag(this.tagToFilter);
    this.showOptionsMenu = false;
  }
}
